import React, { useState } from "react";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DesktopLoginForm from "@/components/DesktopLoginForm";
import MobileLoginForm from "@/components/MobileLoginForm";
import { useDispatch } from "react-redux";
import { authAction } from "@/redux/actions/auth.action";

const schema = Yup.object().shape({
	email: Yup.string().email("Invalid email").required("Email is required"),
	password: Yup.string().required("Password is required"),
	agree: Yup.boolean().oneOf([true], "You must accept the terms"),
});
const Login = () => {
	const [loginError, setLoginError] = useState(null);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [showDesktopPassword, setShowDesktopPassword] = useState(false);
	const desktopForm = useForm({
		resolver: yupResolver(schema),
	});

	const [showMobilePassword, setShowMobilePassword] = useState(false);
	const mobileForm = useForm({
		resolver: yupResolver(schema),
	});

	const onSubmit = async (data) => {
		try {
			const result = await dispatch(authAction.login(data));

			if (result?.success) {
				navigate("/products");
			} else {
				setLoginError(result?.error || "Login failed");
			}
		} catch (error) {
			//console.error("Login failed:", error);
			setLoginError(
				error?.error || error.message || "An unexpected error occurred"
			);
		}
	};
	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Login"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="flex justify-center mt-[28px] h-[700px] hidden lg:flex h-[700px]">
				<div className="w-[361px] h-[358px] flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					{loginError && (
						<div className="text-red-500 text-sm mb-4">{loginError}</div>
					)}
					<DesktopLoginForm
						register={desktopForm.register}
						errors={desktopForm.formState.errors}
						handleSubmit={desktopForm.handleSubmit}
						onSubmit={onSubmit}
						showPassword={showDesktopPassword}
						setShowPassword={setShowDesktopPassword}
					/>

					<div className="w-[321px] h-[32px] flex items-center gap-[8px] justify-center">
						<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34]">
							OR
						</p>
					</div>

					<button className="w-[321px] h-[32px] flex items-center justify-center gap-[10px] rounded-[24px] px-[6px] py-[8px] border bg-[#F1F6E9]">
						<img
							src="/assets/login/google.svg"
							alt="Google Icon"
							className="w-[19px] h-[19px]"
						/>
						<span className="text-[13px] font-[500] font-montserrat text-[#193D34] text-center">
							Login with Google
						</span>
					</button>
				</div>
			</div>

			{/* Mobile View  */}
			<ImageBanner type="mobile" title="Login" />
			<div className="flex justify-center mt-[180px] h-[607px] lg:hidden">
				<div className="w-[95%] max-w-[361px] flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					<MobileLoginForm
						register={mobileForm.register}
						errors={mobileForm.formState.errors}
						handleSubmit={mobileForm.handleSubmit}
						onSubmit={onSubmit}
						showPassword={showMobilePassword}
						setShowPassword={setShowMobilePassword}
					/>
					<div className="w-full h-[32px] flex items-center justify-center gap-[10px]">
						<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34]">
							OR
						</p>
					</div>

					<button className="w-full h-[32px] flex items-center justify-center gap-[10px] rounded-[24px] px-[6px] py-[8px] border bg-[#F1F6E9]">
						<img
							src="/assets/login/google.svg"
							alt="Google Icon"
							className="w-[19px] h-[19px]"
						/>
						<span className="text-[13px] font-[500] font-montserrat text-[#193D34] text-center">
							Login with Google
						</span>
					</button>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default Login;
